import React from 'react';
import { MapPin, User } from 'lucide-react';

const FieldSkeleton = ({ labelWidth = '35%', valueWidth = '70%' }) => (
  <div className="mb-2">
    <div className="shimmer shimmer-line" style={{ marginBottom: 6, width: labelWidth, height: 10 }} />
    <div className="shimmer shimmer-line" style={{ width: valueWidth, height: 12 }} />
  </div>
);

const ContactRowSkeleton = () => (
  <div className="py-2 tinyFont border-bottom">
    <div className="shimmer shimmer-line mb-1" style={{ width: '55%', height: 12 }} />
    <div className="shimmer shimmer-line" style={{ width: '40%', height: 10 }} />
  </div>
);

export const AssociationDetailSkeleton = () => (
  <div
    className="bg-white border shadow-sm overflow-hidden"
    style={{ borderRadius: 10 }}
    aria-busy="true"
    aria-label="Loading association details"
  >
    <div className="px-3 py-3" style={{ background: '#1F4E8C' }}>
      <div className="d-flex justify-content-between align-items-center">
        <div className="shimmer shimmer-line" style={{ width: '60%', height: 16 }} />
      </div>
    </div>

    <div className="px-3 py-3 border-bottom">
      <h4 className="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3 tinyFont text-muted fw-bold">
        ASSOCIATION INFO
        <span className="mt-1 mt-md-0 ml-0 ml-md-2 px-2 py-1 xtinyFont fw-bold bg-green-light text-success rounded-lg">
          CLIENT-VISIBLE
        </span>
      </h4>
      <div className="row">
        <div className="col-12 col-md-6">
          <FieldSkeleton labelWidth="30%" valueWidth="65%" />
        </div>
        <div className="col-12 col-md-6">
          <FieldSkeleton labelWidth="25%" valueWidth="75%" />
        </div>
      </div>

      <div>
        <h4 className="mt-3 mb-1 xtinyFont text-muted">
          <User size={12} className="mr-1" />
          CONTACTS
        </h4>
        <ContactRowSkeleton />
        <div className="py-2 tinyFont">
          <div className="shimmer shimmer-line mb-1" style={{ width: '50%', height: 12 }} />
          <div className="shimmer shimmer-line" style={{ width: '35%', height: 10 }} />
        </div>
      </div>
    </div>

    <div className="px-3 py-3 border-bottom">
      <h4 className="d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3 tinyFont text-muted fw-bold">
        MANAGEMENT
        <span
          className="mt-1 mt-md-0 ml-0 ml-md-2 px-2 py-1 xtinyFont fw-bold rounded-lg"
          style={{
            background: '#fff3e0',
            color: '#e65100',
          }}
        >
          PROCESSOR-ONLY
        </span>
      </h4>

      <div
        className="d-inline-flex border rounded mb-3"
        style={{ overflow: 'hidden' }}
      >
        <span className="px-3 py-1 tinyFont text-break" style={{ color: 'var(--gray)' }}>
          Has management company
        </span>
        <span className="px-3 py-1 tinyFont text-break" style={{ color: 'var(--gray)' }}>
          Self-managed
        </span>
      </div>

      <FieldSkeleton labelWidth="40%" valueWidth="80%" />
      <div className="row">
        <div className="col-12 col-md-6">
          <FieldSkeleton labelWidth="30%" valueWidth="60%" />
        </div>
        <div className="col-12 col-md-6">
          <FieldSkeleton labelWidth="25%" valueWidth="70%" />
        </div>
      </div>
      <div className="mt-2">
        <div className="text-muted tinyFont">How to Order</div>
        <div className="shimmer shimmer-line mt-1" style={{ width: '90%', height: 12 }} />
        <div className="shimmer shimmer-line mt-1" style={{ width: '75%', height: 12 }} />
      </div>
    </div>

    <PropertyAddressesSkeleton />
  </div>
);

export const PropertyAddressesSkeleton = () => (
  <div className="p-3" aria-busy="true" aria-label="Loading property addresses">
    <div className="text-muted tinyFont d-flex align-items-center">
      <MapPin size={14} className="mr-1" />
      Property Addresses
    </div>
    <div className="text-dark smallFont mt-2 d-flex flex-column">
      {['65%', '55%', '45%'].map(width => (
        <div
          key={width}
          className="shimmer mb-1 align-self-start"
          style={{ width, height: 28, borderRadius: 999 }}
        />
      ))}
    </div>
  </div>
);
